import { BodyLarge, Center, Column, HeadlineLarge, TitleLarge } from '../../../styles';
import {
    BookmarkStarIcon,
    FilledButton,
    InstitutionRow,
    TabBar,
    ProjectRow
} from '../../../components';
import { useBreakpoint, useNavigateTo } from '../../../hooks';
import { Box } from '@mui/material';
import { Project } from '../../../types/Project';
import { Institution } from '../../../types/Institution';
import { ROUTES } from '../../../../constants';
import { getBreakpointValue } from '../../../types';

import type { JSX } from "react";

type Props = {
    projects: Project[];
    companies: Institution[];
};

export const DashboardScreenFavouritesSection = ({ projects, companies }: Props) => {
    const breakpoint = useBreakpoint();
    const navigateTo = useNavigateTo();
    const hasProjects = projects.length > 0;
    const hasCompanies = companies.length > 0;
    const isEmpty = !hasProjects && !hasCompanies;

    const renderFavouriteProjects = () => (
        <Column gap={1}>
            {projects.map((project) => (
                <ProjectRow key={project.documentId} project={project} />
            ))}
        </Column>
    );

    const renderFavouriteCompanies = () => (
        <Column gap={1}>
            {companies.map((company) => (
                <InstitutionRow key={company.documentId} institution={company} />
            ))}
        </Column>
    );
    const tabHeadlines: string[] = [];
    const tabContents: JSX.Element[] = [];

    if (hasCompanies) {
        tabHeadlines.push('Firmen');
        tabContents.push(renderFavouriteCompanies());
    }

    if (hasProjects) {
        tabHeadlines.push('Projekte');
        tabContents.push(renderFavouriteProjects());
    }

    const renderEmptyContent = () => (
        <Center gap={1} py={6} px={getBreakpointValue(breakpoint, 4, 6, 6)}>
            <BookmarkStarIcon />

            <HeadlineLarge textAlign={'center'}>Noch keine Favoriten</HeadlineLarge>
            <BodyLarge textAlign={'center'} maxWidth={500}>
                Schauen Sie sich um und markieren Sie Ideen, die Ihnen gefallen.
            </BodyLarge>
            <FilledButton label='Zur Übersicht' onClick={() => navigateTo(ROUTES.Companies)} />
        </Center>
    );

    const renderFavourites = () => <TabBar tabHeadlines={tabHeadlines} tabContents={tabContents} />;

    return (
        <Box mx={3} my={4}>
            <TitleLarge mb={3}>Meine Favoriten</TitleLarge>
            {isEmpty ? renderEmptyContent() : renderFavourites()}
        </Box>
    );
};
